var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer",style:(_vm.style),on:{"click":_vm.handleClick}},[_c(_vm.layer.component,{tag:"component",attrs:{"layer":_vm.layer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }